<template>
  <div class="login-layout">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.login-layout {
  min-height: 100dvh;
  padding: 1.25rem;
  background: var(--portal-bg);
}
</style>
